import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 764.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,764.000000) scale(0.100000,-0.100000)" >
<path d="M2861 6059 c-245 -30 -505 -155 -648 -311 -28 -31 -43 -42 -47 -33
-7 19 10 174 23 208 13 33 14 57 3 57 -10 0 -85 -114 -116 -177 -57 -114 -77
-213 -88 -433 -14 -291 -3 -380 67 -527 116 -248 332 -420 680 -547 466 -168
619 -232 709 -294 21 -14 59 -51 83 -82 43 -52 45 -57 39 -104 -20 -175 -190
-333 -426 -398 -72 -19 -107 -23 -230 -22 -126 1 -157 5 -233 28 -160 48 -263
113 -343 217 -52 68 -90 89 -159 89 -32 0 -51 -6 -65 -20 -20 -20 -20 -31 -18
-283 l3 -262 45 0 c53 0 61 12 85 127 10 47 22 78 31 82 10 4 43 -22 97 -77
139 -140 294 -226 475 -264 95 -19 337 -13 452 12 138 31 291 90 397 156 18
12 33 17 33 12 0 -29 -47 -141 -81 -194 -22 -34 -37 -65 -32 -70 12 -12 131
80 194 149 154 168 232 364 232 582 0 187 -53 326 -181 481 -157 190 -353 338
-802 604 -258 153 -448 284 -589 405 -24 20 -24 20 -6 65 56 149 242 293 442
342 92 22 267 22 353 0 169 -44 325 -158 408 -297 53 -89 78 -105 159 -105
104 0 99 -15 106 362 4 175 10 345 13 377 6 55 6 59 -12 51 -56 -22 -186 -16
-260 12 -11 4 3 -18 32 -52 28 -33 65 -80 81 -105 31 -45 31 -46 19 -115 -12
-78 -31 -93 -58 -48 -26 44 -111 137 -184 202 -176 157 -431 231 -683 200z"/>
<path d="M5693 4615 c-24 -17 -53 -93 -53 -141 0 -71 93 -121 139 -75 42 42
40 170 -4 209 -30 26 -52 28 -82 7z"/>
<path d="M6457 4563 c-22 -57 -45 -211 -53 -360 l-7 -133 -28 20 c-74 54 -212
67 -284 29 -92 -49 -171 -143 -204 -242 -23 -68 -28 -195 -10 -260 14 -53 61
-101 127 -134 141 -69 278 -8 365 162 l26 50 1 -86 c0 -47 5 -100 11 -117 12
-34 44 -51 62 -33 6 6 21 11 33 11 l21 0 -1 333 c-1 272 2 356 17 467 31 220
33 282 11 302 -11 9 -31 19 -45 23 -23 6 -28 2 -42 -32z m-216 -528 c19 -10
49 -31 68 -47 l33 -29 25 23 26 23 -7 -60 c-24 -210 -138 -354 -280 -355 -43
0 -53 4 -86 38 -29 29 -40 50 -50 97 -27 131 28 295 110 329 27 10 126 -1 161
-19z"/>
<path d="M5025 4526 c-124 -59 -192 -191 -210 -411 l-7 -80 -59 -28 c-33 -15
-59 -34 -59 -42 0 -8 5 -15 10 -15 6 0 10 -9 10 -20 0 -11 1 -20 3 -20 1 0 23
7 50 15 l47 14 0 -217 c0 -230 7 -282 43 -307 20 -14 23 -14 33 0 7 9 18 14
25 13 11 -2 15 47 22 267 4 148 9 270 10 272 2 1 56 8 120 15 97 10 117 15
117 29 0 11 12 18 38 23 57 9 64 8 58 -11 -12 -39 -24 -392 -16 -462 9 -79 32
-124 68 -129 43 -7 49 25 56 298 4 140 10 271 14 290 l8 35 91 10 c103 12 125
24 121 69 l-3 31 -103 0 -102 0 0 25 c0 14 5 67 10 119 11 105 8 127 -20 136
-50 16 -68 -24 -100 -223 -10 -61 -15 -73 -33 -77 -12 -2 -48 -9 -81 -16 -41
-8 -60 -16 -63 -29 -4 -14 -20 -19 -79 -24 -41 -4 -82 -10 -91 -13 -14 -5 -15
4 -8 78 14 172 39 284 73 322 23 26 70 18 96 -16 17 -24 21 -44 23 -123 2
-101 4 -108 33 -124 17 -9 22 -5 40 31 12 23 24 70 27 108 5 55 2 75 -17 119
-39 90 -102 112 -195 68z"/>
<path d="M7473 4155 c-85 -43 -160 -144 -177 -237 -6 -34 -4 -38 24 -53 17 -9
41 -15 53 -13 19 3 23 11 27 68 3 36 13 81 22 100 18 42 71 90 98 90 64 0 101
-57 104 -157 l1 -65 -62 -23 c-192 -73 -350 -265 -299 -363 71 -135 227 -115
343 43 l22 30 0 -43 c1 -58 41 -101 92 -99 33 2 34 3 32 42 -1 22 -5 67 -8
101 -5 41 0 111 14 215 20 144 20 158 6 214 -29 111 -85 164 -182 172 -49 4
-66 0 -110 -22z m153 -441 c-10 -39 -118 -173 -165 -204 -24 -17 -57 -30 -72
-30 -112 0 10 198 176 287 l60 32 3 -31 c2 -17 1 -41 -2 -54z"/>
<path d="M5641 4133 c-20 -73 -32 -297 -25 -458 7 -157 8 -160 35 -187 32 -32
50 -35 71 -10 13 14 17 72 23 346 7 363 10 346 -57 346 -35 0 -38 -3 -47 -37z"/>
<path d="M6855 4119 c-124 -66 -215 -224 -215 -373 0 -158 80 -270 215 -301
175 -41 320 78 333 274 6 87 -1 87 -54 3 -71 -112 -128 -152 -219 -152 -112 0
-175 76 -175 210 0 42 3 80 6 83 4 3 25 -9 47 -28 46 -39 84 -49 163 -43 101
9 178 86 177 178 -1 58 -23 101 -68 136 -50 38 -152 44 -210 13z m140 -79 c11
-12 18 -35 18 -60 0 -74 -69 -116 -148 -90 -20 7 -41 20 -48 31 -6 10 -17 19
-24 19 -19 0 -16 9 12 45 49 65 154 95 190 55z"/>
<path d="M4296 4114 c-177 -64 -285 -313 -216 -497 50 -134 206 -201 354 -151
58 20 134 92 163 155 66 141 50 323 -37 422 -63 71 -122 90 -194 61 -16 -6
-18 -4 -13 9 8 20 -4 21 -57 1z m138 -112 c52 -48 76 -116 76 -213 0 -98 -17
-165 -55 -214 -80 -105 -203 -78 -241 52 -37 127 -4 278 82 372 35 39 41 42
73 36 20 -4 49 -19 65 -33z"/>
<path d="M1840 3385 c0 -55 3 -163 7 -241 l6 -141 41 15 c55 19 170 10 305
-23 58 -14 108 -24 113 -23 5 2 -18 22 -51 45 -139 99 -252 216 -349 363 -30
47 -59 89 -64 95 -4 5 -8 -36 -8 -90z"/>
<path d="M2168 2352 c-16 -3 -18 -17 -18 -118 l0 -114 25 0 c23 0 25 4 25 45
0 43 1 45 30 45 60 0 100 69 66 115 -13 18 -91 35 -128 27z m80 -54 c16 -16
-3 -48 -28 -48 -16 0 -20 7 -20 30 0 22 5 30 18 30 10 0 23 -5 30 -12z"/>
<path d="M2391 2347 c-58 -30 -83 -111 -52 -169 35 -66 132 -76 184 -18 21 24
27 40 27 78 0 54 -18 85 -60 107 -35 18 -67 19 -99 2z m75 -45 c22 -14 35 -53
29 -83 -11 -49 -60 -64 -95 -29 -50 50 9 150 66 112z"/>
<path d="M2560 2351 c0 -3 14 -57 31 -118 31 -109 33 -113 60 -113 26 0 29 5
45 60 9 33 19 58 23 55 3 -3 12 -29 21 -58 13 -44 20 -52 42 -55 26 -3 28 1
48 70 12 40 26 86 31 102 15 48 12 58 -18 54 -25 -3 -28 -9 -41 -70 -8 -38
-18 -68 -21 -68 -4 0 -15 32 -25 70 -15 60 -21 70 -40 70 -20 0 -25 -9 -40
-75 -10 -41 -19 -75 -21 -75 -1 0 -11 33 -20 74 -16 69 -20 74 -46 78 -16 3
-29 2 -29 -1z"/>
<path d="M2908 2352 c-16 -3 -18 -17 -18 -118 l0 -114 65 0 c63 0 65 1 65 25
0 23 -4 25 -41 25 -36 0 -40 2 -37 23 2 18 10 23 41 25 28 2 37 8 37 22 0 14
-9 20 -37 22 -31 2 -39 7 -41 26 -3 20 1 22 37 22 34 0 41 3 41 20 0 12 -7 20
-17 21 -65 4 -80 4 -95 1z"/>
<path d="M3272 2352 c-22 -3 -23 -6 -20 -115 3 -108 4 -112 26 -115 15 -2 22
2 23 15 2 37 -1 216 -3 217 -2 1 -13 0 -26 -2z"/>
<path d="M3340 2238 l0 -118 25 0 c23 0 24 3 27 71 l3 71 45 -69 c36 -54 50
-68 70 -68 25 0 25 0 28 111 l3 112 -25 4 c-14 3 -28 3 -31 0 -3 -3 -5 -35 -5
-71 l0 -66 -44 69 c-35 56 -49 70 -70 71 l-26 1 0 -118z"/>
<path d="M3618 2345 c-56 -31 -74 -113 -39 -171 52 -86 182 -60 198 40 l6 36
-57 0 c-49 0 -56 -2 -56 -20 0 -15 7 -20 25 -20 27 0 32 -9 13 -28 -34 -34
-88 2 -88 60 0 56 43 83 92 57 16 -8 24 -8 34 3 36 36 -75 73 -128 43z"/>
<path d="M3932 2344 c-40 -21 -62 -60 -62 -112 0 -62 58 -112 129 -112 37 0
64 21 55 43 -5 13 -14 16 -44 11 -33 -5 -43 -2 -64 19 -31 31 -33 56 -7 88 16
20 28 24 64 22 33 -1 47 3 52 14 8 23 -6 34 -51 39 -25 3 -51 -2 -72 -12z"/>
<path d="M4139 2346 c-39 -22 -59 -60 -59 -110 0 -64 38 -106 101 -113 41 -5
50 -2 81 26 58 51 58 133 0 184 -27 25 -90 31 -123 13z m91 -56 c54 -54 -12
-153 -73 -107 -28 21 -32 68 -7 100 25 32 52 35 80 7z"/>
<path d="M4488 2349 c-13 -7 -16 -22 -13 -69 1 -33 -2 -57 -6 -54 -5 2 -25 32
-45 64 -31 51 -41 60 -65 60 l-29 0 0 -115 0 -115 25 0 c23 0 24 3 27 72 l3
71 48 -72 c38 -58 52 -72 70 -69 21 3 22 8 25 114 3 116 -3 134 -40 113z"/>
<path d="M4793 2344 c-2 -6 -2 -57 -1 -115 l3 -104 63 -3 c60 -3 62 -2 62 22
0 21 -5 25 -37 28 -30 2 -38 7 -38 23 0 16 8 21 38 23 28 2 37 8 37 22 0 14
-9 20 -37 22 -30 2 -38 7 -38 23 0 16 8 21 38 23 30 3 37 7 37 25 0 20 -5 22
-61 22 -34 0 -63 -5 -66 -11z"/>
<path d="M5013 2344 c-42 -21 -66 -59 -66 -104 0 -47 17 -76 56 -100 57 -35
147 -19 131 23 -5 13 -14 16 -44 11 -33 -5 -43 -2 -64 19 -31 31 -33 56 -7 88
16 20 28 24 64 22 33 -1 47 3 52 14 8 23 -6 34 -51 39 -24 3 -51 -2 -71 -12z"/>
<path d="M5160 2352 c-5 -2 -10 -12 -10 -23 0 -14 7 -19 25 -19 14 0 25 -3 26
-7 0 -5 1 -46 2 -93 2 -83 2 -85 27 -85 25 0 25 1 28 93 3 90 3 92 27 92 19 0
25 5 25 23 0 21 -4 22 -70 22 -38 0 -74 -1 -80 -3z"/>
<path d="M5353 2353 c-22 -4 -23 -8 -23 -119 l0 -114 25 0 25 0 0 120 c0 66
-1 119 -2 119 -2 -1 -13 -4 -25 -6z"/>
<path d="M5418 2353 c-10 -2 -18 -8 -18 -11 0 -4 20 -54 44 -112 61 -144 70
-144 130 -2 25 60 46 112 46 116 0 3 -13 6 -28 6 -25 0 -30 -6 -46 -52 -36
-100 -36 -100 -66 -18 -28 76 -32 81 -62 73z"/>
<path d="M5642 2345 c-4 -7 -6 -61 -4 -119 3 -105 4 -106 28 -106 l24 0 0 114
c0 105 -1 114 -20 119 -11 3 -23 -1 -28 -8z"/>
<path d="M5720 2352 c-6 -2 -10 -12 -10 -23 0 -14 7 -19 25 -19 24 0 24 -2 27
-92 3 -88 4 -93 26 -96 21 -3 22 -1 22 92 l0 96 30 0 c22 0 30 5 30 18 0 9 18
-10 40 -43 34 -51 40 -68 40 -113 0 -50 2 -53 23 -50 19 3 22 10 25 57 3 43
11 64 42 110 l39 56 -27 3 c-20 3 -33 -4 -54 -30 -23 -27 -30 -30 -37 -18 -33
53 -34 53 -134 54 -54 1 -102 0 -107 -2z"/>
<path d="M6242 2351 c-10 -6 -92 -203 -92 -221 0 -22 47 -10 58 15 10 21 18
25 56 25 38 0 45 -3 50 -25 5 -18 13 -25 31 -25 14 0 25 6 25 13 0 6 -18 58
-41 114 -39 98 -59 122 -87 104z m37 -118 c1 -7 -8 -13 -19 -13 -23 0 -23 0
-9 37 10 26 12 27 19 8 5 -11 9 -26 9 -32z"/>
<path d="M6390 2238 l0 -118 25 0 c24 0 25 2 25 73 l0 72 39 -60 c52 -78 58
-85 81 -85 19 0 20 7 20 119 0 108 -2 119 -17 116 -10 -2 -21 -4 -25 -4 -5 -1
-8 -31 -8 -68 l-1 -68 -42 66 c-32 51 -48 68 -69 71 l-28 5 0 -119z"/>
<path d="M6620 2238 l0 -118 35 0 c120 0 188 112 116 192 -24 28 -37 33 -90
38 l-61 6 0 -118z m98 56 c16 -11 22 -25 22 -54 0 -29 -6 -43 -22 -54 -41 -29
-48 -21 -48 54 0 75 7 83 48 54z"/>
<path d="M6923 2352 c-22 -3 -23 -7 -23 -118 l0 -114 24 0 c23 0 25 5 28 48
l3 47 34 -47 c27 -38 40 -48 63 -48 15 0 28 4 28 8 0 5 -16 27 -36 50 -28 33
-32 43 -21 48 44 17 40 109 -5 118 -43 9 -73 11 -95 8z m75 -68 c2 -13 -4 -24
-13 -28 -24 -9 -35 1 -35 30 0 21 4 25 23 22 13 -2 23 -11 25 -24z"/>
<path d="M7133 2352 l-33 -3 0 -115 0 -114 65 0 c63 0 65 1 65 25 0 23 -4 25
-40 25 -36 0 -40 3 -40 25 0 23 4 25 40 25 33 0 40 3 40 20 0 17 -7 20 -40 20
-36 0 -40 3 -40 25 0 23 4 25 40 25 35 0 40 3 40 23 0 23 -17 27 -97 19z"/>
<path d="M7246 2351 c-2 -3 11 -55 28 -116 31 -108 32 -110 61 -110 26 0 31 5
42 45 22 77 24 78 44 12 19 -59 22 -63 47 -60 25 3 29 11 59 113 18 61 33 113
33 116 0 3 -13 4 -29 1 -27 -4 -31 -9 -46 -73 -10 -39 -20 -68 -23 -65 -2 3
-12 33 -22 67 -12 44 -23 65 -37 70 -18 7 -22 1 -38 -59 -10 -37 -21 -71 -25
-75 -4 -4 -12 18 -19 50 -7 32 -17 64 -21 72 -8 14 -48 23 -54 12z"/>
<path d="M7642 2347 c-7 -10 -25 -53 -89 -214 -3 -9 4 -13 21 -13 18 0 30 8
38 25 9 21 18 25 55 25 37 0 45 -4 53 -25 7 -18 17 -25 35 -25 14 0 25 3 25 8
0 6 -80 212 -85 220 -7 9 -45 9 -53 -1z m43 -104 c5 -20 3 -23 -18 -23 -24 0
-25 2 -14 30 12 31 20 29 32 -7z"/>
<path d="M7793 2344 c-2 -6 -2 -57 -1 -115 3 -104 3 -104 28 -104 21 0 26 5
30 39 l5 38 33 -41 c22 -28 41 -41 57 -41 33 0 31 15 -5 57 l-30 34 20 26 c25
32 26 64 3 92 -14 17 -31 22 -77 24 -35 1 -60 -2 -63 -9z m101 -49 c5 -15 -18
-45 -35 -45 -5 0 -9 14 -9 30 0 23 5 30 19 30 10 0 21 -7 25 -15z"/>
<path d="M8023 2352 l-33 -3 0 -110 c0 -124 1 -126 77 -114 68 10 103 48 103
114 0 82 -53 122 -147 113z m72 -67 c31 -30 32 -56 2 -91 -37 -43 -57 -28 -57
44 0 80 12 91 55 47z"/>
<path d="M8237 2340 c-49 -39 -27 -103 44 -125 10 -4 19 -15 19 -27 0 -17 -5
-19 -27 -16 -16 3 -36 8 -45 12 -11 5 -20 1 -27 -13 -10 -18 -7 -22 18 -36 64
-32 141 -3 141 54 0 30 -17 50 -68 75 -42 22 -36 42 11 39 28 -2 37 2 42 18 9
26 7 27 -40 34 -32 6 -46 2 -68 -15z"/>
<path d="M3052 2238 l3 -113 25 0 c18 0 25 6 26 20 1 11 2 29 3 40 1 16 8 12
37 -22 24 -29 44 -43 60 -43 32 0 30 18 -7 56 l-32 33 22 27 c25 32 27 61 5
92 -13 19 -24 22 -80 22 l-65 0 3 -112z m98 48 c0 -24 -27 -43 -41 -29 -14 14
2 53 22 53 13 0 19 -7 19 -24z"/>
<path d="M4562 2238 c3 -108 4 -113 25 -116 21 -3 22 1 25 69 l3 72 48 -71
c37 -57 52 -72 72 -72 l25 0 0 115 0 115 -25 0 c-23 0 -24 -3 -27 -67 l-3 -68
-43 68 c-38 58 -48 67 -73 67 l-30 0 3 -112z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
